import React, { useState } from 'react';
import { useI18n } from '../i18n/i18n';
import './ExerciseTechniqueCard.css';

/**
 * Built-in vector templates for movement patterns to ensure immediate visual rendering
 * and zero layout shifts even on slow gym mobile connections.
 */
function renderMovementVector(pattern, activePhase) {
    if (pattern === 'horizontal_press' || pattern === 'incline_press' || pattern === 'decline_press') {
        if (activePhase === 0) {
            // Lockout / Setup
            return (
                <svg className="technique-vector-svg" viewBox="0 0 400 220" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Bench press lockout position">
                    <rect x="70" y="150" width="260" height="12" rx="4" fill="#1D2638" stroke="rgba(255,255,255,0.14)"/>
                    <rect x="185" y="162" width="30" height="38" fill="#111620"/>
                    <path d="M110 146 Q190 138 270 146" stroke="#475569" strokeWidth="16" strokeLinecap="round"/>
                    <circle cx="100" cy="142" r="10" fill="#64748B"/>
                    <circle cx="140" cy="144" r="6" fill="#CCFF00" className="vector-glow-volt"/>
                    <line x1="160" y1="140" x2="160" y2="60" stroke="#00E5FF" strokeWidth="8" strokeLinecap="round" className="vector-glow-cyan"/>
                    <line x1="200" y1="140" x2="200" y2="60" stroke="#00E5FF" strokeWidth="8" strokeLinecap="round" className="vector-glow-cyan"/>
                    <rect x="60" y="54" width="280" height="8" rx="4" fill="#E2E8F0"/>
                    <rect x="68" y="40" width="16" height="36" rx="4" fill="#94A3B8"/>
                    <rect x="316" y="40" width="16" height="36" rx="4" fill="#94A3B8"/>
                    <text x="200" y="34" fill="#CCFF00" fontFamily="'Space Grotesk', monospace" fontSize="11" fontWeight="700" textAnchor="middle">LOCKOUT: FULL TIGHTNESS</text>
                </svg>
            );
        } else if (activePhase === 1) {
            // Inflection / Chest Touch
            return (
                <svg className="technique-vector-svg" viewBox="0 0 400 220" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Bench press chest touch inflection position">
                    <rect x="70" y="150" width="260" height="12" rx="4" fill="#1D2638" stroke="rgba(255,255,255,0.14)"/>
                    <rect x="185" y="162" width="30" height="38" fill="#111620"/>
                    <path d="M110 146 Q190 132 270 146" stroke="#475569" strokeWidth="16" strokeLinecap="round"/>
                    <circle cx="100" cy="142" r="10" fill="#64748B"/>
                    <path d="M150 138 L125 132 L160 110" stroke="#00E5FF" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" className="vector-glow-cyan"/>
                    <path d="M210 138 L235 132 L200 110" stroke="#00E5FF" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" className="vector-glow-cyan"/>
                    <path d="M180 60 Q180 90 180 104" stroke="#CCFF00" strokeWidth="2" strokeDasharray="4,4" className="vector-glow-volt"/>
                    <polygon points="180,108 176,100 184,100" fill="#CCFF00"/>
                    <rect x="60" y="106" width="280" height="8" rx="4" fill="#E2E8F0"/>
                    <rect x="68" y="92" width="16" height="36" rx="4" fill="#94A3B8"/>
                    <rect x="316" y="92" width="16" height="36" rx="4" fill="#94A3B8"/>
                    <circle cx="180" cy="128" r="12" fill="rgba(204,255,0,0.3)" className="vector-glow-volt"/>
                    <text x="200" y="86" fill="#CCFF00" fontFamily="'Space Grotesk', monospace" fontSize="11" fontWeight="700" textAnchor="middle">STRETCH: NO BOUNCE</text>
                </svg>
            );
        } else {
            // Concentric Drive Arc
            return (
                <svg className="technique-vector-svg" viewBox="0 0 400 220" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Bench press upward drive arc position">
                    <rect x="70" y="150" width="260" height="12" rx="4" fill="#1D2638" stroke="rgba(255,255,255,0.14)"/>
                    <rect x="185" y="162" width="30" height="38" fill="#111620"/>
                    <path d="M110 146 Q190 134 270 146" stroke="#475569" strokeWidth="16" strokeLinecap="round"/>
                    <path d="M270 146 L295 180 L320 180" stroke="#CCFF00" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" className="vector-glow-volt"/>
                    <path d="M180 110 Q170 80 160 60" stroke="#CCFF00" strokeWidth="3" strokeLinecap="round" className="vector-glow-volt"/>
                    <polygon points="160,56 156,66 166,64" fill="#CCFF00"/>
                    <line x1="150" y1="136" x2="165" y2="75" stroke="#00E5FF" strokeWidth="8" strokeLinecap="round" className="vector-glow-cyan"/>
                    <line x1="210" y1="136" x2="195" y2="75" stroke="#00E5FF" strokeWidth="8" strokeLinecap="round" className="vector-glow-cyan"/>
                    <rect x="60" y="70" width="280" height="8" rx="4" fill="#E2E8F0"/>
                    <rect x="68" y="56" width="16" height="36" rx="4" fill="#94A3B8"/>
                    <rect x="316" y="56" width="16" height="36" rx="4" fill="#94A3B8"/>
                    <text x="200" y="34" fill="#00E5FF" fontFamily="'Space Grotesk', monospace" fontSize="11" fontWeight="700" textAnchor="middle">UPWARD ARC TOWARDS EYE-LINE</text>
                </svg>
            );
        }
    }

    if (pattern === 'squat' || pattern === 'lunge') {
        if (activePhase === 0) {
            return (
                <svg className="technique-vector-svg" viewBox="0 0 400 220" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Squat setup position">
                    <line x1="60" y1="190" x2="340" y2="190" stroke="#1D2638" strokeWidth="6"/>
                    <circle cx="200" cy="40" r="10" fill="#64748B"/>
                    <line x1="200" y1="50" x2="200" y2="120" stroke="#475569" strokeWidth="14" strokeLinecap="round"/>
                    <line x1="195" y1="120" x2="190" y2="190" stroke="#00E5FF" strokeWidth="9" strokeLinecap="round" className="vector-glow-cyan"/>
                    <line x1="205" y1="120" x2="210" y2="190" stroke="#00E5FF" strokeWidth="9" strokeLinecap="round" className="vector-glow-cyan"/>
                    <rect x="70" y="50" width="260" height="8" rx="4" fill="#E2E8F0"/>
                    <text x="200" y="24" fill="#CCFF00" fontFamily="'Space Grotesk', monospace" fontSize="11" fontWeight="700" textAnchor="middle">BRACE CORE • CHEST TALL</text>
                </svg>
            );
        } else if (activePhase === 1) {
            return (
                <svg className="technique-vector-svg" viewBox="0 0 400 220" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Squat bottom depth position">
                    <line x1="60" y1="190" x2="340" y2="190" stroke="#1D2638" strokeWidth="6"/>
                    <line x1="90" y1="135" x2="310" y2="135" stroke="#CCFF00" strokeWidth="1.5" strokeDasharray="4,4" className="vector-glow-volt"/>
                    <circle cx="190" cy="90" r="10" fill="#64748B"/>
                    <line x1="190" y1="100" x2="175" y2="140" stroke="#475569" strokeWidth="14" strokeLinecap="round"/>
                    <line x1="175" y1="140" x2="225" y2="135" stroke="#CCFF00" strokeWidth="9" strokeLinecap="round" className="vector-glow-volt"/>
                    <line x1="225" y1="135" x2="210" y2="190" stroke="#00E5FF" strokeWidth="9" strokeLinecap="round" className="vector-glow-cyan"/>
                    <rect x="70" y="95" width="260" height="8" rx="4" fill="#E2E8F0"/>
                    <text x="200" y="70" fill="#CCFF00" fontFamily="'Space Grotesk', monospace" fontSize="11" fontWeight="700" textAnchor="middle">PARALLEL / SUB-PARALLEL DEPTH</text>
                </svg>
            );
        } else {
            return (
                <svg className="technique-vector-svg" viewBox="0 0 400 220" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Squat concentric drive position">
                    <line x1="60" y1="190" x2="340" y2="190" stroke="#1D2638" strokeWidth="6"/>
                    <path d="M140 150 L140 90" stroke="#CCFF00" strokeWidth="3" strokeLinecap="round" className="vector-glow-volt"/>
                    <polygon points="140,84 136,94 144,94" fill="#CCFF00"/>
                    <path d="M260 150 L260 90" stroke="#CCFF00" strokeWidth="3" strokeLinecap="round" className="vector-glow-volt"/>
                    <polygon points="260,84 256,94 264,94" fill="#CCFF00"/>
                    <circle cx="200" cy="55" r="10" fill="#64748B"/>
                    <line x1="200" y1="65" x2="198" y2="125" stroke="#475569" strokeWidth="14" strokeLinecap="round"/>
                    <line x1="198" y1="125" x2="195" y2="190" stroke="#00E5FF" strokeWidth="9" strokeLinecap="round" className="vector-glow-cyan"/>
                    <rect x="70" y="60" width="260" height="8" rx="4" fill="#E2E8F0"/>
                    <text x="200" y="34" fill="#00E5FF" fontFamily="'Space Grotesk', monospace" fontSize="11" fontWeight="700" textAnchor="middle">DRIVE THROUGH MID-FOOT</text>
                </svg>
            );
        }
    }

    // Default athletic movement vector
    return (
        <svg className="technique-vector-svg" viewBox="0 0 400 220" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Athletic movement execution">
            <line x1="60" y1="190" x2="340" y2="190" stroke="#1D2638" strokeWidth="6"/>
            <circle cx="200" cy="50" r="12" fill="#64748B"/>
            <line x1="200" y1="62" x2="200" y2="125" stroke="#475569" strokeWidth="14" strokeLinecap="round"/>
            <line x1="195" y1="125" x2="185" y2="190" stroke="#00E5FF" strokeWidth="9" strokeLinecap="round" className="vector-glow-cyan"/>
            <line x1="205" y1="125" x2="215" y2="190" stroke="#00E5FF" strokeWidth="9" strokeLinecap="round" className="vector-glow-cyan"/>
            <path d="M160 90 L200 75 L240 90" stroke="#CCFF00" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" className="vector-glow-volt"/>
            <text x="200" y="30" fill="#CCFF00" fontFamily="'Space Grotesk', monospace" fontSize="11" fontWeight="700" textAnchor="middle">STABLE KINETIC CHAIN</text>
        </svg>
    );
}

export default function ExerciseTechniqueCard({ guide }) {
    const { t } = useI18n();
    const [activePhaseIndex, setActivePhaseIndex] = useState(1);
    // Asset cascade state: 0 = exercise image, 1 = pattern image, 2 = muscle image, 3 = vector only
    const [assetStage, setAssetStage] = useState(0);

    if (!guide) return null;

    const pattern = guide.pattern || 'full_body';
    const patternName = guide.patternName || t("exerciseDetails.techniqueCard.fallbackBadge");
    const phases = (guide.phases && guide.phases.length > 0) ? guide.phases : [
        { name: t("exerciseDetails.techniqueCard.phase1"), label: t("exerciseDetails.techniqueCard.phase1Sub"), cue: "Setup posture." },
        { name: t("exerciseDetails.techniqueCard.phase2"), label: t("exerciseDetails.techniqueCard.phase2Sub"), cue: "Full range inflection." },
        { name: t("exerciseDetails.techniqueCard.phase3"), label: t("exerciseDetails.techniqueCard.phase3Sub"), cue: "Concentric return." }
    ];

    const safePhaseIndex = Math.min(Math.max(activePhaseIndex, 0), phases.length - 1);
    const currentPhase = phases[safePhaseIndex];
    const postureChecks = guide.postureChecks || {};

    const handleImageError = () => {
        // Cascade downwards
        setAssetStage(prev => prev + 1);
    };

    let currentImageSrc = null;
    if (assetStage === 0 && guide.cardAsset) {
        currentImageSrc = guide.cardAsset;
    } else if (assetStage === 1 && guide.patternAsset) {
        currentImageSrc = guide.patternAsset;
    } else if (assetStage === 2 && guide.muscleAsset) {
        currentImageSrc = guide.muscleAsset;
    }

    return (
        <article className="exercise-technique-card" data-testid="exercise-technique-card">
            {/* Top Bar with Pattern Name & Phase Counter */}
            <div className="technique-card-topbar">
                <span className="technique-pattern-badge" data-testid="technique-pattern-badge">
                    ⚡ {patternName}
                </span>
                <span className="technique-phase-counter">
                    {safePhaseIndex + 1} / {phases.length}
                </span>
            </div>

            {/* Illustration Visual Stage */}
            <div className="technique-illustration-stage">
                {currentImageSrc && assetStage < 3 ? (
                    <img 
                        src={currentImageSrc} 
                        alt={`${guide.name} technique form`} 
                        className="technique-image-asset" 
                        onError={handleImageError} 
                    />
                ) : (
                    renderMovementVector(pattern, safePhaseIndex)
                )}
            </div>

            {/* Phase Selector Toolbar (Minimum 48px Touch Targets for Gym Ergonomics) */}
            <div className="technique-phase-toolbar" role="tablist" aria-label="Movement phases">
                {phases.map((phase, idx) => (
                    <button
                        key={idx}
                        type="button"
                        className={`technique-phase-btn ${idx === safePhaseIndex ? 'active' : ''}`}
                        onClick={() => setActivePhaseIndex(idx)}
                        role="tab"
                        aria-selected={idx === safePhaseIndex}
                        data-testid={`phase-btn-${idx + 1}`}
                    >
                        <span className="phase-btn-label">{phase.name}</span>
                        <span className="phase-btn-sub">{phase.label || `PHASE ${idx + 1}`}</span>
                    </button>
                ))}
            </div>

            {/* Dynamic Active Phase Cue */}
            <div className="technique-cue-box">
                <div className="technique-cue-icon" aria-hidden="true">💡</div>
                <div className="technique-cue-text">
                    <h4 className="technique-cue-title">{currentPhase.name}</h4>
                    <p className="technique-cue-desc" data-testid="active-phase-cue">{currentPhase.cue}</p>
                </div>
            </div>

            {/* Mandatory Posture Alignment Checks (Head & Leg Alignment) */}
            <div className="technique-posture-checks" data-testid="posture-checklist">
                <h4 className="posture-checklist-title">
                    🛡️ {t("exerciseDetails.techniqueCard.postureChecklistTitle")}
                </h4>
                <div className="posture-check-item" data-testid="head-check-item">
                    <span className="posture-item-icon" aria-hidden="true">👤</span>
                    <div className="posture-item-content">
                        <strong>{t("exerciseDetails.techniqueCard.headCheckLabel")}:</strong>{' '}
                        <span>{postureChecks.head || "Maintain neutral cervical spine alignment."}</span>
                    </div>
                </div>
                <div className="posture-check-item" data-testid="legs-check-item">
                    <span className="posture-item-icon" aria-hidden="true">🦵</span>
                    <div className="posture-item-content">
                        <strong>{t("exerciseDetails.techniqueCard.legsCheckLabel")}:</strong>{' '}
                        <span>{postureChecks.legs || "Plant feet firmly for an unshakeable ground foundation."}</span>
                    </div>
                </div>
            </div>
        </article>
    );
}
